// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { parseBoolean, getABtestFromState } from '@tcp/core/src/utils';

const allLayouts = (state) => state.Layouts;
const allModules = (state) => state.Modules;
const allSeo = (state) => state.SEOData;
const allApiConfig = (state) => state.APIConfig;

export const allModulesData = createSelector(allModules, (allModulesDta) => allModulesDta);

export const getFontsForPage = createSelector(allLayouts, (layouts) => {
  return layouts?.home?.fonts;
});

export const getEnableFullPageAuth = (state) => {
  return state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.ENABLE_FULL_PAGE_LOGIN_REGISTRATION
    ? parseBoolean(state.session.siteDetails.ENABLE_FULL_PAGE_LOGIN_REGISTRATION)
    : false;
};

export const getPlccOfferTakeOverABTest = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return !isEmpty(getAbtests) ? parseBoolean(getAbtests.plccOfferTakeOverABTest) : null;
};

export const getLazyloadModules = (state) => {
  const { lazyloadModules = true } = getABtestFromState(state.AbTest);
  return lazyloadModules;
};

export const getModulesToRemove = (state) => {
  const { removeModules = [] } = getABtestFromState(state.AbTest);
  return removeModules;
};

export const getPlccModalPersistentCookieExpiry = (state) => {
  return state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.PLCC_SIGNUP_MODAL_PERSISTENT_COOKIE_EXPIRY !== undefined
    ? parseInt(state.session.siteDetails.PLCC_SIGNUP_MODAL_PERSISTENT_COOKIE_EXPIRY, 10)
    : 120;
};

export const getMinibagOnHoverEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.MINIBAG_HOVER_ENABLED)
  );
};

export const hpSeoData = createSelector(allSeo, (seoData) => seoData.home);

const hpLayout = createSelector(allLayouts, allApiConfig, (Layouts = {}, apiConfig = {}) => {
  const keyIfAltHome =
    apiConfig.originalPath &&
    apiConfig.originalPath
      .split('/')
      .pop()
      .replace(/-([a-z])/g, (g) => {
        return g[1].toUpperCase();
      });
  return Layouts.home || Layouts[keyIfAltHome];
});
export const hpSlots = createSelector(
  hpLayout,
  getModulesToRemove,
  (home, modulesToRemove = []) => {
    const moduleToBeRemovedIndexArr = [];
    if (home?.slots) {
      home.slots.forEach((slot, i) => {
        if (modulesToRemove.indexOf(slot.contentId) !== -1) {
          moduleToBeRemovedIndexArr.push(i);
        }
      });
      for (let j = 0; j < moduleToBeRemovedIndexArr.length; j += 1) {
        home.slots.splice(moduleToBeRemovedIndexArr[j], 1);
      }
      return home.slots;
    }
    return [];
  }
);

export default {
  hpSeoData,
  getEnableFullPageAuth,
  allModulesData,
  hpSlots,
};
